import buildSimpleStringFilter from '../buildSimpleStringFilter'

const CarrierFilter = buildSimpleStringFilter({
  key: 'carrier',
  expandedOnInit: false,
})

export default CarrierFilter
